<template>
  <div class="invoice" id="Invoice">
	  <div class="content-container container">
   	   <div class="content">
   		   <div class="section_header">
   			   <!-- <img :src="require(`@/assets/images/logo.png`)" alt=""> -->
   			   <div class="header_content">

   				   <h3 v-if= "accountType =='premier'">2023 Chicago Cubs premier Invoice</h3>
				   <h3 v-if= "accountType =='suite'">2023 Chicago Cubs Suite Holder Invoice</h3>
   				   <div class="cubs_address">
   					   <p>Wrigley Field</p>
   					   <p>1060 West Addison Street</p>
   					   <p>Chicago, IL 60613-4397</p>
   				   </div>
   			   </div>
   		   </div>
   		   <div class="inner-container">
   			   <div class="personalInfo-section">
   				   <table class="table table-bordered ">
   					   <tr>
   						   <td class="title">Date</td>
   						   <td  v-if= "accountType =='premier'">10/20/22</td>
						    <td  v-if= "accountType =='suite'">10/20/22</td>
						   <!-- <td  v-if= "accountType =='suite'">01/18/2023</td> -->
   					   </tr>
   					   <tr>
   						   <td class="title" v-if= "accountType =='premier'">Premier Client</td>
						   <td class="title" v-if= "accountType =='suite'">Suite Holder</td>
   						   <td>{{purl.fullName}}</td>
   					   </tr>
   					   <tr>
   						   <td class="title">Account Number</td>
   						   <td>{{purl.accountId}}</td>
   					   </tr>
   					   <tr>
   						   <td class="title">Email Address</td>
   						   <td>{{purl.email_address}}</td>
   					   </tr>
   				   </table >
				   <table class="table table-bordered">
					   <tr>
						   <td class="title">Your Representative</td>
						   <td>{{repInfo?.name}}</td>
					   </tr>
					   <tr>
						   <td class="title">Representative Email</td>
						   <td>{{repInfo?.email}}</td>
					   </tr>
					   <tr>
						   <td class="title">Representative Phone Number</td>
						   <td>{{repInfo?.phone}}</td>
					   </tr>

				   </table>
   			   </div>

   			   <!-- Invoice Deatils -->
   			   <div class="invoice_details table-responsive">
   				   <table class="table ">
   					   <thead>
   						   <tr>
   							   <th scope="col">Plan</th>
   							   <th scope="col">Section</th>
   							   <th scope="col">Row</th>
   							   <th scope="col">Seat(s)</th>
   							   <th scope="col">Quantity</th>
   							   <th scope="col">Price/seat</th>
   							   <th scope="col">ticket Price</th>
   						   </tr>
   					   </thead>
   					   <tbody>
						   <tr v-for="account in uniqAccountInfo" :key="account.id">
								   <td class="text-center">{{ account.package_type }}</td>
								   <td class="text-center">{{ account.section }}</td>
								   <td class="text-center">{{ account.row }}</td>
								   <td class="text-center">{{ account.seat_range }}</td>
								   <td class="text-center">{{ account.seat_quantity }}</td>
								   <td class="text-center">${{ parseFloat(account.seat_price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
								   <td class="text-center">${{ parseFloat( account.ticket_price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
						   </tr>
   					   </tbody>
   				   </table>
   			   </div>
   	   <!-- total section -->
   			   <div class="price_total_section">
   				   <div class="total_section">
					   <table class="table  table-bordered">
						   <tr>
							   <td class="title">subtotal</td>
							   <td class="text-center">{{purl.sth_2023_balance}}</td>
						   </tr>
						   <tr>
							   <td class="title">12% amusement tax</td>
							   <td class="text-center">{{purl.amusement_tax}}</td>
						   </tr>
						   <tr>
							   <td class="title">Processing Fee</td>
							   <td class="text-center">{{purl.process_fee}}</td>
						   </tr>
						   <tr>
							   <td class="title">Total Balance Due</td>
							   <td class="text-center">{{purl.total_balance_due}}</td>
						   </tr>
						   <tr>
							   <td class="title">Previous Credits/Payments</td>
							   <td class="text-center">{{purl.credit_payment}}</td>
						   </tr>
						   <tr  v-if= "accountType =='premier'">
							   <td class="title">*20% NONREFUNDABLE FIRST PAYMENT DUE 11/16/2022 AFTER CREDITS ARE APPLIED</td>
							   <td class="text-center">{{purl.due_20_percentage}}</td>
						   </tr>
						   <tr v-if= "accountType =='premier'">
							   <td class="title">Total Balance Due 1/18/2023 After Credits Are Applied</td>
							   <td class="text-center">{{purl.total_balance_due}}</td>
						   </tr>
						   <tr  v-if= "accountType =='suite'">
							   <td class="title">Total Balance Due 1/18/2023 After Credits Are Applied</td>
							   <td class="text-center">{{purl.total_balance_due}}</td>
						   </tr>
					   </table>
   					   <div class="" v-if= "accountType =='premier'">
   						   <p>
   							   *Credits are not automatically applied. To apply credits, log in to your “My Cubs Tickets” account and apply credits in the payment tab.
   						   </p>
   						   <p>
   							  <span v-if= "purlTemplate !== 'CREE'"> Please note the price for 2023 Daily Plan Premier Club season tickets includes a customizable seat tag.
   							   Premier Club members will have the option to personalize this seat tag with an account name.</span>
   							   Please note the Chicago Cubs do not provide advice or guidance on the tax deductibility of any marketing expense associated with your seats.
   						   </p>
   					   </div>
   				   </div>
   			   </div>

   			   <!-- Payment Plan Information -->
   			   <div class="payment_plan_section" v-if= "accountType =='premier'">
   				   <div class="header">
   					   <h3>Payment Plan Information</h3>
   				   </div>
   				   <div class="payment_options">
   					   <div class="traditional_option">
   						   <h3>traditional payment option</h3>
   						   <p>
   							   20% of ticket balance due by 5 p.m. CST Wednesday, November 16, 2022.
   							   Remaining 80% ticket balance due by 5 p.m. CST Wednesday, January 18, 2023.
   						   </p>
   					   </div>
   					   <div class="full_payment">
   						   <h3>pay in full</h3>
   						   <p>
   							   Submit the full payment for your season ticket balance by Wednesday, November 16, 2022.
   						   </p>
   					   </div>
   				   </div>
   				   <p>
   					   PLEASE NOTE: If we do not receive your non-refundable first payment and/or full payment by the deadlines indicated above, your Season Ticket account and tenure may be discontinued.
   				   </p>
   			   </div>
   			   <!--Renew Season ticket online -->
   			   <div class="renew_online_section" v-if= "accountType =='premier'">
   				   <div class="renew_section">
   					   <div class="header">
   						   <h3>how to renew your season tickets online</h3>
   					   </div>
   					   <div class="renew_options">
   						   <ul>
   							   <li>Visit "My Cubs Tickets" online at cubs.com/mytickets.</li>
   							   <li>Call or email your Premier Service Account Executive {{repInfo?.name}} at {{repInfo?.phone}} or {{repInfo?.email}}</li>
   							   <li>Mail: Chicago Cubs<br>
   								   &nbsp;24878 Network Place<br>
   								   &nbsp;Chicago, IL  60673-1248<br>
   								   *Please add your account number on your check
   							   </li>
   						   </ul>
   					   </div>

   				   </div>
   			   </div>
			    <div class="renew_online_section" v-if= "accountType =='suite'">

				</div>
   			   <div class="terms">
   				   <p>
   					   By purchasing season tickets I understand and agree all tickets are subject to the terms thereon and agree to be bound by the Chicago Cubs Season Ticket License Terms and Conditions available at: <a href="https://www.cubs.com/sthterms" target="_blank">www.cubs.com/sthterms.</a>
   				   </p>
   			   </div>

   		   </div>


   	   </div>


      </div>
  </div>
</template>


<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "Invoice",
  setup() {
    const store = useStore();

    // State
    const state = reactive({
		purl: computed(() => store.getters["purl/getAccount"]),
  	  uniqAccountInfo : computed(() => store.getters["purl/getUniqAccount"]),
  	  getTotal_discount: computed(
  		  () => store.getters["purl/getTotal_discount"]
  	  ),
  	  getTotal2022Balance: computed(
  		  () => store.getters["purl/getTotal2022Balance"]
  	  ),
  	  getTotal2023Balance: computed(
  		  () => store.getters["purl/getTotal2023Balance"]
  	  ),
  	  repInfo: computed(
  		  () => store.getters["purl/getAccountRep"]
  	  ),
  	  paymentInfo: computed( () => store.getters["purl/getPaymentInfo"] ),

  	  accountType: computed(
  		  () => store.getters["purl/getAccountType"]
  	  ),
	  purlTemplate: computed( () => store.getters["purl/getPurlTemplate"] ),

      todaysDate: computed(() =>
        new Date().toLocaleString("en-us", {
          month: "long",
          year: "numeric",
          day: "numeric",
        })
      ),
    });
    // console.log("state", state.accounts);
    return { ...toRefs(state), store };
  },

};
</script>

<style lang="scss" scoped>


</style>
